export default "__VITE_ASSET__4Vye8vhD__"